<div class="login-shell d-flex flex-column min-vh-100">
  <main class="flex-grow-1 d-flex align-items-center justify-content-center py-5 px-3">
    <div class="login-card card shadow-lg">
      <div class="card-body p-4 p-md-5">
        <div class="text-center mb-4">
          <img
            [src]="brandService.brand.logoDark"
            [alt]="brandService.brand.name"
            class="login-logo mb-3"
          />
          <p class="text-muted small mb-0">Sign in to view and pay your invoice</p>
        </div>

        @if (errorMessage) {
          <div class="alert alert-danger" role="alert">
            {{ errorMessage }}
          </div>
        }

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <div class="mb-3">
            <label for="domain" class="form-label">Domain</label>
            <input
              type="text"
              id="domain"
              class="form-control"
              formControlName="domain"
              placeholder="e.g. example.com"
              [class.is-invalid]="loginForm.get('domain')?.touched && loginForm.get('domain')?.invalid"
            />
            @if (loginForm.get('domain')?.touched && loginForm.get('domain')?.invalid) {
              <div class="invalid-feedback">Domain is required.</div>
            }
          </div>

          <div class="mb-3">
            <label for="zipCode" class="form-label">Zip Code</label>
            <input
              type="text"
              id="zipCode"
              class="form-control"
              formControlName="zipCode"
              placeholder="e.g. 12345"
              [class.is-invalid]="loginForm.get('zipCode')?.touched && loginForm.get('zipCode')?.invalid"
            />
            @if (loginForm.get('zipCode')?.touched && loginForm.get('zipCode')?.invalid) {
              <div class="invalid-feedback">Zip code is required.</div>
            }
          </div>

          <div class="mb-4">
            <label for="phoneNumber" class="form-label">Phone Number</label>
            <input
              type="text"
              id="phoneNumber"
              class="form-control"
              formControlName="phoneNumber"
              placeholder="e.g. 555-123-4567"
              [class.is-invalid]="loginForm.get('phoneNumber')?.touched && loginForm.get('phoneNumber')?.invalid"
            />
            @if (loginForm.get('phoneNumber')?.touched && loginForm.get('phoneNumber')?.invalid) {
              <div class="invalid-feedback">Phone number is required.</div>
            }
          </div>

          <button type="submit" class="btn btn-portal-accent btn-lg w-100" [disabled]="loading">
            @if (loading) {
              <span class="spinner-border spinner-border-sm me-1" role="status"></span>
              Signing in...
            } @else {
              Sign In
            }
          </button>
        </form>

        <p class="text-center text-muted small mt-4 mb-0">
          Need help signing in? Call or text
          <a class="text-portal-secondary fw-semibold" [href]="brandService.brand.phoneHref">{{
            brandService.brand.phone
          }}</a>
        </p>
      </div>
    </div>
  </main>
  <app-portal-footer></app-portal-footer>
</div>
